import React, {useState, useMemo, useEffect, useContext} from 'react'
import { useDispatch } from 'react-redux'
import { IWarhouseListItem } from '../../../../../modules/API/Defaults/models/warhouseList'
import { IProductMlaiForCreate } from '../../../../../modules/API/Mlai/models/productsForCreate'
import { Mlai } from '../../../../../modules/API/Mlai/mlai'
import ControlSearchPannelLayout from '../../../../../generic/Layouts/Wrappers/ControlSearchPannelLayout'
import DatePickerModule from '../../../../../generic/datePicker/datePicker'
import SearchInput from '../../../../../generic/inputs/inputSearch'
import BodyScrollContainer from '../../../../../generic/Layouts/Wrappers/BodyScrollContainer'
import TitlesList from '../../../../../generic/titlesRowItem/TitlesList'
import ProductItem from './ProductItem'
import { useNavigate, useParams } from 'react-router-dom'
import { LOAD, LOAD_END } from '../../../../../../store/actions/actionsTypes'
import ControlButton from '../../../../../generic/buttons/ControlButton'
import styled from 'styled-components'
import { LINKS } from '../../../../../Routs/config'
import WarehouseFilter from './WarehouseFilter'
import { addIDForTheList } from '../../../../../generic/utils/addUIDForTheList'
import FlexColumnLayout from '../Layouts/FlexColumnLayout'
import { ContextMlai } from '../Context/MlaiContext'
import useBeforeUnload from '../../../../../generic/hooks/useBeforeUnload'
import { ITitleMlaiItem } from '../../../../../modules/API/Mlai/models/title'
import MlaiTitleItem from '../Components/MlaiTitleItem'
import useMlaiController from '../hooks/useMlaiController'
import ColumModal from '../../../../../generic/Layouts/ColumModal'
import useDataFetcher from '../../knisot/hooks/useFetchData'
import { Defaults } from '../../../../../modules/API/Defaults/defaults'
import { IGrowerNodeGetResponse, IGrowerItem } from '../../../../../modules/API/Defaults/models/growers'
import GrowerSelectorModal from './GrowerSelectorModal'
import AddProductModal from './AddProductModal'
import { IProductsWithVarietyItem } from '../../../../../modules/API/Defaults/models/compliteProducts'
import CircleActiveFilterBtn from '../../../../../generic/particles/CircleActiveFilterBtn'
import PlusIcon from '../../../../../generic/icons/IconLib/PlusIcon'
import { useProductCreationFieldsControl } from '../../settings/FeatureControl/services/hooks/useProductCreationFieldsControl'

const MlaiCreateMain = () => {
  const dispatch = useDispatch()
  const {id, subID} = useParams() as {id: string, subID: string}

  const navigate = useNavigate()
  
  const {
    date,
    setDate,
    tranzit,
    isCustomer,
    warehouseList,
    defaultWarehouse
  } = useContext(ContextMlai)

  const {
    postProducts,
    putProducts,
    changeQty
  } = useMlaiController()

  const [productsList, setProductsList] = useState<IProductMlaiForCreate[]>([])
  const [selectedTranzit, setSelectedTranzit] = useState<IWarhouseListItem | null>(null)
  const [titleData, setTitleData] = useState<ITitleMlaiItem | null>(null)
  const [selectedProduct, setSelectedProduct] = useState<IProductMlaiForCreate | null>(null)
  const [isGrowerModalOpen, setIsGrowerModalOpen] = useState<boolean>(false)
  const [isAddProductModalOpen, setIsAddProductModalOpen] = useState<boolean>(false)
  const [defaultProduct, setDefaultProduct] = useState<{
    ProductID: number
    VarietyID: number
    SizeID: string
    PackageID: number
  } | null>(null)

  const [input, setInput] = useState<string>('')

  const {
    productCreationFields,
    productCreationFieldsDict,
    isLoading: isLoadingProductCreationFields,
  } = useProductCreationFieldsControl();

  // Fetch grower list
  const {
    data: growerData,
    isLoading: isLoadingGrowers
  } = useDataFetcher<IGrowerNodeGetResponse>(
    Defaults.getGrowerList, 'data'
  )

  // Fetch product list
  const {
    data: productList
  } = useDataFetcher<IProductsWithVarietyItem[]>(
    Defaults.getProductsWithVariety, 'data'
  )

  const growerList = growerData?.growers || []

  const getProducts = async (tranzitID: number | string) => {
    if(subID !== '0') return
    dispatch({type: LOAD})
    try {
      const res = await Mlai.getProductsForCreate(tranzitID.toString())
      setProductsList(addIDForTheList(res))
    } catch (error) {
      
    } finally {
      dispatch({type: LOAD_END})
    }
  }

  const handlePostProducts = async () => {
    if(!productsList) return
    
    const tranzitID = isCustomer ? Number(tranzit || 0) : Number(selectedTranzit?.WarehouseID || 0)
    postProducts(
      productsList,
      date,
      tranzitID,
      id,
      0
    ) 
  }

  const handlePutProduct = async () => {
    if(!titleData) return
    try {
      const result = await putProducts(productsList, titleData, subID)
      if(result) {
        setProductsList(result)
      }
    } catch {}
  }

  const handleSaveFunc = async (item: IProductMlaiForCreate) => {
    const newArr = [...productsList]
    const index = newArr.findIndex(i => i.id === item.id)
    newArr[index].isEdited = false
    setProductsList(newArr)
    if(subID !== '0') {
      await handlePutProduct()
    } else {
      await handlePostProducts()
    }
  }

  const saveAndExit = async () => {
    if(subID !== '0') {
      await handlePutProduct()
      navigate(LINKS.mlai.mlai.mainURL)

    } else {
      await handlePostProducts()
    }
  }

  const handleChangeQty = (qty: number, item: IProductMlaiForCreate) => {
    if(!productsList) return
    const result = changeQty(productsList, qty, item)
    setProductsList(result)
  }

  const handleOpenGrowerModal = (product: IProductMlaiForCreate) => {
    setSelectedProduct(product)
    setIsGrowerModalOpen(true)
  }

  const handleCloseGrowerModal = () => {
    setIsGrowerModalOpen(false)
    setSelectedProduct(null)
  }

  const handleGrowerSelect = (growerID: number) => {
    if (!selectedProduct || !productsList) return
    
    const selectedGrower = growerList.find(grower => grower.GrowerID === growerID)
    if (!selectedGrower) return

    const updatedProductsList = productsList.map(product => {
      if (product.id === selectedProduct.id) {
        return {
          ...product,
          GrowerID: growerID,
          GrowerName: selectedGrower.GrowerName
        }
      }
      return product
    })
    
    setProductsList(updatedProductsList)
    handleCloseGrowerModal()
  }

  const handleAddProduct = (product: {
    ProductID: number
    VarietyID: number
    SizeID: string
    GrowerID: number
    GrowerName: string
    Qty: number
    ProductDesc: string
    VarietyDesc: string
    PackageID: number
  }) => {
    const newProduct: IProductMlaiForCreate = {
      id: Math.random().toString(),
      ProductID: product.ProductID,
      VarietyID: product.VarietyID,
      SizeID: product.SizeID,
      GrowerID: product.GrowerID,
      GrowerName: product.GrowerName,
      NumPackagesActulal: product.Qty,
      NumPackagesReg: 0,
      NumPalletsActual: 0,
      NumPalletsReg: 0,
      WeightActual: 0,
      WeightReg: 0,
      EntryPackages: 0,
      EntryPallets: 0,
      EntryWeight: 0,
      ExitPackages: 0,
      ExitPallets: 0,
      ExitWeight: 0,
      MonetaryValue: 0,
      PackingID: product.PackageID,
      Price: 0,
      QualityID: 0,
      RecID: 0,
      Remarks: '',
      Season: 0,
      CodeStock: 0,
      GeneralProductID: 0,
      VarietyDesc: product.VarietyDesc,
      ProductDesc: product.ProductDesc,
      MiddleWeight: 0,
      isEdited: false
    }

    setProductsList([...productsList, newProduct])
    setIsAddProductModalOpen(false)
  }

  const handleOpenAddModal = (product: IProductMlaiForCreate) => {
    setDefaultProduct({
      ProductID: product.ProductID,
      VarietyID: product.VarietyID,
      SizeID: product.SizeID,
      PackageID: product.PackingID
    })
    setIsAddProductModalOpen(true)
  }

  const handleCloseAddModal = () => {
    setIsAddProductModalOpen(false)
    setDefaultProduct(null)
  }

  const getMlaiData = async (subID: number) => {
    dispatch({type: LOAD})
    try {
      const res = await Mlai.getMlaiItem(subID)
      setTitleData(res)
      setProductsList(addIDForTheList(res.Details))
    } catch {

    } finally {
      dispatch({type: LOAD_END})
    }
  }

  const renderProducts = useMemo(() => {
    if(!productsList) return []
    return productsList.filter(item => 
      `${item.ProductDesc.trim()} ${item.VarietyDesc.trim()}`.includes(input)
    )
  }, [productsList, input])

  const productProps = {
    handleChangeQty: handleChangeQty,
    handleSaveFunc: handleSaveFunc,
    handleOpenGrowerModal: handleOpenGrowerModal,
    handleOpenAddModal: handleOpenAddModal
  }

  useEffect(() => {
    if(isCustomer ? !tranzit : !selectedTranzit  ) return setProductsList([])
    const tranzitID = isCustomer ? (tranzit || 0) : (selectedTranzit?.WarehouseID || 0)
    getProducts(tranzitID || defaultWarehouse)
  }, [tranzit, selectedTranzit, defaultWarehouse])

  useEffect(() => {
    if(subID !== '0') {
      getMlaiData(Number(subID))
    }
  }, [subID])

  useBeforeUnload()
  return (
    <FlexColumnLayout>
      {
        subID !== '0' && titleData ?
        <>
        <MlaiTitleItem
          TypeStock={titleData.TypeStock || 0}
          RecID={titleData.RecID || 0}
          Remarks={titleData.Remarks || ''}                                                                                                                                                                                     
          Season={titleData.Season || 0}
          StatusStock={titleData.StatusStock || 0}
          TimeStock={titleData.TimeStock || ""}
          TranzitID={titleData.TranzitID || 0}
          WorkerID={titleData.WorkerID || 0}
          CodeStock={titleData.CodeStock || 0}
          DateStock={titleData.DateStock || ''}
          WarehouseDesc={titleData.WarehouseDesc || ''}
        />
          <ControlSearchPannelLayout>
            <CircleActiveFilterBtn
              func={() => setIsAddProductModalOpen(true)}
            >
              <PlusIcon />
            </CircleActiveFilterBtn>
            <SearchInput 
              input={input}
              setInput={setInput}
            />
          </ControlSearchPannelLayout>
        </>
        : 
        <ControlSearchPannelLayout>
          <CircleActiveFilterBtn
            func={() => setIsAddProductModalOpen(true)}
          >
            <PlusIcon />
          </CircleActiveFilterBtn>
          <DatePickerModule
            setSelectedDateStart={setDate}
            setSelectedDateEnd={false}
            defEndDate={false}
            selected={false}
            ignorBrod={true}
            disabled={false}
            large
          />
          <SearchInput 
            input={input}
            setInput={setInput}
          />
          {
            !isCustomer &&
              <WarehouseFilter
                defaultID={defaultWarehouse}
                list={warehouseList || []}
                required={!selectedTranzit}
                selectedWarehouse={selectedTranzit}
                setSelectedWarehouse={setSelectedTranzit}
              />
          }
        </ControlSearchPannelLayout>
      }
      <BodyScrollContainer>
        <TitlesList 
          list={renderProducts}
          uniqueKey={'id'}
          noPadding={false}
          Element={ProductItem}
          additionalData={productProps}
        />
      </BodyScrollContainer>
      <ControlWrapper>
        <ControlButton
          lable={'חזרה'}
          handleClick={() => navigate(LINKS.mlai.mlai.mainURL)}
        />
        <ControlButton 
          lable={'סיום'}
          handleClick={saveAndExit}
        />
      </ControlWrapper>
      {
        isGrowerModalOpen && selectedProduct && (
          <ColumModal
            title="בחר מגדל"
            controlFunc={handleCloseGrowerModal}
            Children={GrowerSelectorModal}
            childrenProps={{
              growerList,
              selectedGrowerID: selectedProduct.GrowerID || 0,
              onGrowerSelect: handleGrowerSelect,
              closeFunc: handleCloseGrowerModal
            }}
          />
        )
      }
      {
        isAddProductModalOpen && (
          <ColumModal
            title="הוסף פריט"
            controlFunc={handleCloseAddModal}
            Children={AddProductModal}
            childrenProps={{
              productList: productList || [],
              growerList,
              onClose: handleCloseAddModal,
              onAdd: handleAddProduct,
              defaultProduct: defaultProduct,
              productCreationFields: productCreationFields,
              productCreationFieldsDict: productCreationFieldsDict,
            }}
          />
        )
      }
    </FlexColumnLayout>
  )
}

export default MlaiCreateMain

const ControlWrapper = styled.div`
    width: 100%;
    display: flex;
    gap: 0.5em;
`